/**
 * 28/07/2026 — Bug prod « valeur totale du marché appliquée en gain
 * journalier » (AO Mairie de Tours : 48 240 €/j au lieu de 402 €/j).
 * Les contrats AO gagnés portaient `revenue = prix/j × durée` (TOTAL)
 * alors que `acceptContract` lit `revenue` comme un montant JOURNALIER.
 * Répare les contrats corrompus des sauvegardes au rehydrate : le prix
 * journalier négocié est reconstruit depuis dailyRevenueBase/Bonus
 * (posés par buildContractFromTender) + multiplicateurs d'acceptation.
 */

const CORRUPTION_FACTOR = 8; // dailyRevenue/revenue > 8× le prix/j négocié = corrompu

function repairOne(c) {
  if (!c || !c.tenderWon) return null;
  const base = Math.round((c.dailyRevenueBase || 0) + (c.dailyRevenueBonus || 0));
  if (base <= 0) return null;
  const daily = c.dailyRevenue || 0;
  if (daily > base * CORRUPTION_FACTOR) {
    // Contrat déjà affecté : dailyRevenue = total × multiplicateurs.
    const mult = (c.argumentationMultiplier || 1) * (1 - (c.outOfZonePenalty || 0));
    const legit = Math.round(base * mult);
    return { ...c, dailyRevenue: legit, revenue: legit, totalValue: legit * (c.duration || 0) };
  }
  if ((c.revenue || 0) > base * CORRUPTION_FACTOR) {
    // Contrat encore en attente de staffing : revenue portait le TOTAL.
    return { ...c, revenue: base, totalValue: c.revenue };
  }
  return null;
}

/** Répare une liste de contrats. Retourne { contracts, repaired }. */
export function repairTenderContracts(list) {
  let repaired = 0;
  const contracts = (list || []).map(c => {
    const fixed = repairOne(c);
    if (fixed) { repaired += 1; return fixed; }
    return c;
  });
  return { contracts, repaired };
}

/**
 * Répare activeContracts, availableContracts et pendingTransferContracts
 * d'un état persisté. Retourne le nombre total de contrats réparés et
 * MUTE `state` (usage : onRehydrateStorage).
 */
export function repairTenderContractsInState(state) {
  let total = 0;
  ['activeContracts', 'availableContracts'].forEach(key => {
    if (Array.isArray(state[key]) && state[key].some(c => c && c.tenderWon)) {
      const { contracts, repaired } = repairTenderContracts(state[key]);
      if (repaired > 0) { state[key] = contracts; total += repaired; }
    }
  });
  if (Array.isArray(state.pendingTransferContracts) && state.pendingTransferContracts.length > 0) {
    let touched = false;
    const next = state.pendingTransferContracts.map(p => {
      const fixed = p && p.contract ? repairOne(p.contract) : null;
      if (fixed) { touched = true; total += 1; return { ...p, contract: fixed }; }
      return p;
    });
    if (touched) state.pendingTransferContracts = next;
  }
  return total;
}
